// RA list date formatting — shared by the job rows and the scope tree.
export const fmtDMY = (iso) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso || "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${m}/${d}/${y.slice(2)}`;
};
const daysFromToday = (iso) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${iso}T00:00:00`) - today) / 86400000);
};
// Date colour carries the countdown: late = red, within a week = amber, otherwise plain.
export const dateTone = (iso) => {
  if (!iso) return "";
  const n = daysFromToday(iso);
  if (n < 0) return "text-red-600 font-semibold";
  if (n <= 7) return "text-amber-700 font-medium";
  return "text-gray-700";
};
// RA note: "Weeks out" — days from today ÷ 7; under a week reads "<1 wk"; a passed date reads late.
export const weeksOut = (iso) => {
  if (!iso) return { text: "", tone: "" };
  const n = daysFromToday(iso);
  if (n < 0) return { text: `${-n}d late`, tone: "text-red-600 font-semibold" };
  if (n < 7) return { text: "<1 wk", tone: "text-amber-700 font-medium" };
  return { text: `${Math.round(n / 7)} wks`, tone: "text-gray-700" };
};
export const dateTitle = (iso) => {
  if (!iso) return "";
  const n = daysFromToday(iso);
  return n < 0 ? `${-n} day${n === -1 ? "" : "s"} late` : n === 0 ? "today" : `in ${n} day${n === 1 ? "" : "s"}`;
};
export const latestOf = (dates) => dates.filter(Boolean).sort().slice(-1)[0] || "";
